import React, { useEffect, useState } from "react";
import InfoCard from "../components/InfoCard";
import infoImg1 from "../assets/images/icon.png";
import TransactionTable from "../components/TransactionTable";
import { useAccountStats } from "../hooks/useAccount";
import { formatPrice, getWeb3 } from "../helper/functions";
import { DEFAULT_CHAIN, afterDate, api_key, contract, dateFormat, networkQuery, userTransactionQuery } from "../helper/constant";
import { useAccount, useNetwork } from "wagmi";
import dividendAbi from "../abi/dividend.json";
import { useEthersSigner } from "../hooks/useEthersProvider";
import { toast } from "react-toastify";
import { getContract } from "../helper/contractHelper";
import { useSidebar } from "../context/useSidebar";

export default function Account() {
  const { isSidebarOpen, isRightSidebarOpen } = useSidebar();
  const [updater, setUpdater] = useState(1);
  const accStats = useAccountStats(updater);
  const [dexData, setDexData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [tloading, setTLoading] = useState(false);
  const { address } = useAccount();
  const { chain } = useNetwork();
  const signer = useEthersSigner();
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const variables = {
    limit: 100,
    offset: 0,
    network: networkQuery,
    token: contract[DEFAULT_CHAIN].BARC_ADDRESS,
    after: afterDate,
    dateFormat: dateFormat,
    user: address ? address : "",
  };

  useEffect(() => {
    if (address) {
      try {
        var config = {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-API-KEY": api_key,
          },
          body: JSON.stringify({
            query: userTransactionQuery,
            variables: variables,
          }),
        };

        fetch("https://graphql.bitquery.io", config)
          .then((response) => response.json())
          .then((response) => {
            if (response.data) {
              setDexData(response.data.ethereum.dexTrades);
              setLoading(false);
            } else {
              console.log(response);
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      } catch (err) {
        console.log(err.message);
      }
    }

    // eslint-disable-next-line
  }, [address]);

  const handleClaimReward = async () => {
    setTLoading(true);
    if (address) {
      if (parseInt(chain.id) === parseInt(DEFAULT_CHAIN)) {
        try {
          let dividendContract = getContract(dividendAbi, contract[DEFAULT_CHAIN].DIVIDEND_ADDRESS, signer);

          let tx = await dividendContract.claim({ from: address });
          toast.loading("Waiting for confirmation...");
          var interval = setInterval(async function () {
            let web3 = getWeb3();
            var response = await web3.eth.getTransactionReceipt(tx.hash);
            if (response != null) {
              clearInterval(interval);
              if (response.status === true) {
                toast.dismiss();
                toast.success("Your last transaction is success!!");
                setTLoading(false);
                setUpdater(Math.random());
              } else if (response.status === false) {
                toast.error("error ! Your last transaction is failed.");
                setTLoading(false);
              } else {
                toast.error("error ! something went wrong.");
                setTLoading(false);
              }
            }
          }, 5000);
        } catch (err) {
          toast.error(err.reason ? err.reason : err.message);
          setTLoading(false);
        }
      } else {
        toast.error("Please select Ethereum Mainnet !");
        setTLoading(false);
      }
    } else {
      toast.error("Please Connect Wallet!");
      setTLoading(false);
    }
  };

  return (
    <div
      className={`content-body default-height bg-primary-gradient ${isSidebarOpen ? "sidebar-open-page-margin" : "sidebar-close-page-margin"}`}
      style={{
        paddingRight: screenWidth > 1700 && isRightSidebarOpen ? "26.75rem" : "0",
      }}
    >
      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-12">
            <div className="row">
              <div className="col-xl-12">
                <div className="page-titles">
                  <nav aria-label="breadcrumb">
                    <ol className="breadcrumb">
                      <li className="breadcrumb-item">
                        <a href="#sec">Dashboard</a>
                      </li>
                      <li className="breadcrumb-item active" aria-current="page">
                        Rewards
                      </li>
                    </ol>
                  </nav>
                </div>
              </div>
              <div className="col-12 col-xl-4">
                <InfoCard
                  data={{
                    img: infoImg1,
                    number: accStats.token_balance ? formatPrice(accStats.token_balance) : 0,
                    name: "YOUR BALANCE",
                    col: "col-12 col-xl-6",
                    iconclass: "fa-2x fa-wallet fa-solid fas",
                  }}
                />
              </div>
              <div className="col-12 col-xl-4">
                <InfoCard
                  data={{
                    img: infoImg1,
                    number: `$${accStats.holdingWorth ? formatPrice(accStats.holdingWorth) : 0}`,
                    name: "HOLDING WORTH",
                    col: "col-12 col-xl-6",
                    iconclass: "fa-2x fa-dollar-sign fa-solid fas",
                  }}
                />
              </div>
              <div className="col-12 col-xl-4">
                <InfoCard
                  data={{
                    img: infoImg1,
                    number: `$${accStats.rewardWorth ? formatPrice(accStats.rewardWorth) : 0}`,
                    name: "YOUR REWARD WORTH",
                    col: "col-12 col-xl-6",
                    iconclass: "fa-2x fa-circle-dollar-to-slot fas fas-solid",
                  }}
                />
              </div>
              <div className="col-12">
                <div className="counter card">
                  <div className="card-body p-4">
                    <div className="media d-flex align-items-center">
                      <div className="card-box-icon">
                        <i className="fa-2x fa-chart-pie fa-solid fas"></i>
                      </div>

                      <div className="chart-num">
                        <h2 className="mb-0">{accStats.reward_balance ? formatPrice(accStats.reward_balance) : 0}</h2>
                        <p className="mb-0">YOUR REWARD</p>
                      </div>
                      <div className="media-body text-white text-end">
                        <button disabled={tloading} type="button" onClick={() => handleClaimReward()} className="btn btn-primary">
                          {tloading ? "Loading..." : "Claim Reward"}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <TransactionTable dexData={dexData} loading={loading} stats={accStats} />
        </div>
      </div>
    </div>
  );
}
